// IMPORTS
import React, { useState } from "react";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

// APP
export default function SettingsCard() {
  // TAB STATES
  const [value, setValue] = React.useState("one");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  // List of all YouTube video data (You can replace these with your actual video IDs and titles)
  const videos = [
    { videoId: "HrbyKvNniIM",  },
    { videoId: "BeaJ6eYLyhA",  },
    { videoId: "eYMimlS95Es",  },
    { videoId: "0BAfmjJ2s5Y",  },
    { videoId: "KHmy_cmLzJk",  },
    { videoId: "fLrp9PU-m_0",  },
    { videoId: "b_D-btKRdqY",  },
    { videoId: "WlTr69sZIvM",  },
    { videoId: "13_bgEc8zeY",  },
    { videoId: "3J2-xDraGjU",  },
    { videoId: "VlAZ4wHH4_E",  },
    { videoId: "S7yumNvuahE",  },
    { videoId: "T8ZGFtpJdCs",  },
    { videoId: "g1JJ1iavc0M",  },
    { videoId: "uIajVK887GI",  },
    { videoId: "1ct3rcJuXiA",  },
    { videoId: "1_sy4XPulSY",  },
    { videoId: "eYMimlS95Es",  },
    { videoId: "rW2ikA2p3lY",  }
  ];

  return (
    <Card variant="outlined" sx={{ height: "100%", width: "100%" }}>
      {/* TABS */}
      <br />
      <Tabs
        value={value}
        onChange={handleChange}
        textColor="secondary"
        indicatorColor="secondary"
        sx={{ width: '100%' }}
      >
        <Tab value="one" label="Channel Videos" />
        <Tab value="two" label="Resume" />
      </Tabs>
      <Divider />

      {/* MAIN CONTENT CONTAINER */}
      <form>
        <CardContent
          sx={{
            p: 3,
            maxHeight: { md: "80vh" },
            textAlign: { xs: "center", md: "start" },
            overflow: 'auto', // Ensure the content is scrollable
            height: 'auto', // Prevent fixed height to allow content overflow
          }}
        >
          {/* FIELDS */}
          <FormControl fullWidth>
            <Grid container spacing={2}>
              {/* Render all YouTube videos */}
              {videos.map((video, index) => (
                <Grid item xs={12} md={6} key={index}>
                  <LiteYouTubeEmbed
                    id={video.videoId} // Dynamically render video using ID
                    title={"codebyvinit"}
                    noCookie={true}
                    adNetwork={true}
                    playlist={false}
                    poster="hqdefault"
                  />
                </Grid>
              ))}
            </Grid>
          </FormControl>
        </CardContent>
      </form>
    </Card>
  );
}
